import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClientLogVO } from 'src/app/core/api/v1';
import { environment } from 'src/environments/environment';

export type Severity = 'INFO' | 'WARN' | 'ERROR';

@Injectable({
    providedIn: 'root',
})
export class LoggerService {
    private API_URL = environment.API_URL + '/log';

    constructor(private http: HttpClient) {}

    public info(message: string, stacktrace?: string): void {
        this.log(message, 'INFO', stacktrace);
    }

    public warn(message: string, stacktrace?: string): void {
        this.log(message, 'WARN', stacktrace);
    }

    public error(message: string, stacktrace?: string): void {
        this.log(message, 'ERROR', stacktrace);
    }

    private log(message: string, severity: Severity, stacktrace?: string): Subscription {
        const logVO = {} as ClientLogVO;
        logVO.message = message;
        logVO.stacktrace = stacktrace;
        logVO.stacktrace = ''; //ToDo Stacktrace teilweise zu lang für Anzeige
        logVO.severity = severity;
        logVO.url = window.location.href;

        //TODO: Would be nice if we could get the class name of the callee
        //Note: With Angular 15 Stacktraces have been improved!!!
        //logVO.clazz =

        return this.http.post<void>(this.API_URL, logVO).subscribe();
    }
}
